import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;


export const ContainerInterno = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerInternoCheck = styled.div`
  display: flex;
  flex-direction: row;
  margin: 6px 10px;
  align-items: center;
  justify-content: center;
`;
